// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import React, { useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import CustomReport from '../../../components/Analytics/CustomReport';
import { getUserDetails } from '../../../reducers/portalConfig';
import { getFeatureFlagOrgFilterForOrgPublishers } from '../../../reducers/portalConfig';
import {
  fetchApiList,
  fetchApiKeyList,
  fetchAppList,
  fetchAppListForOrgInContext,
  fetchOrgList,
  fetchGatewayList,
  fetchCustomChartData,
  fetchCustomReports,
  saveCustomReport,
  saveChartPanel,
  fetchChartPanels,
  editChartPanel,
} from '../../../actions/metrics';
import {
  getApiMap,
  getApiKeyMap,
  getAppMap,
  getApiKeyDetailsMap,
  getOrgMap,
  getGatewayMap,
  getCustomReports,
  getCustomReportPanels,
} from '../../../reducers/metrics';
import {
  FILTER_ENTITY_TYPE_API, FILTER_ENTITY_TYPE_APP, FILTER_ENTITY_TYPE_ORG } from '../../../constants/filter';

const reportProps = {
  totalPanels: 3,
};

const mapDispatchToProps = (dispatch) => ({
  fetchApiList: ( filterByName ) => dispatch(fetchApiList( { name: filterByName })),
  fetchApiKeyList: () => dispatch(fetchApiKeyList()),
  fetchAppList: ( filterByName ) =>
    dispatch(fetchAppList( { name: filterByName })),
  fetchAppListForOrgInContext: () => dispatch(fetchAppListForOrgInContext()),
  fetchOrgList: ( filterByName ) => dispatch(fetchOrgList( { name: filterByName } )),
  fetchGatewayList: () => dispatch(fetchGatewayList()),
  fetchCustomChartData: (query, chartID) =>
    dispatch(fetchCustomChartData(JSON.stringify(query), chartID)),
  fetchCustomReports: () => dispatch(fetchCustomReports()),
  saveCustomReport: (query) => dispatch(saveCustomReport(JSON.stringify(query))),
  saveChartPanel: (query, reportId) =>
    dispatch(saveChartPanel(JSON.stringify(query), reportId)),
  fetchChartPanels: (reportId) => dispatch(fetchChartPanels(reportId)),
  editChartPanel: (query, reportId, panelId) =>
    dispatch(editChartPanel(JSON.stringify(query), reportId, panelId)),
});

export const mapStateToProps = (state) => {
  const userObj = getUserDetails(state) || {};
  const isFeatureFlagAnalyticsOrgPublisherEnabled = getFeatureFlagOrgFilterForOrgPublishers(state);
  const isExternalUser = userObj && userObj.externalUser;
  const isOrgPublisher = userObj && userObj.orgPublisher
    && isFeatureFlagAnalyticsOrgPublisherEnabled;
  return {
    isExternalUser,
    isOrgPublisher,
    isFeatureFlagAnalyticsOrgPublisherEnabled,
    apiList: getApiMap(state),
    apiKeyList: getApiKeyMap(state),
    apiKeyDetailsMap: getApiKeyDetailsMap(state),
    appList: getAppMap(state),
    orgList: getOrgMap(state),
    gatewayList: getGatewayMap(state),
    customReportState: state,
    customReports: getCustomReports(state),
    customReportPanels: getCustomReportPanels(state),
  };
};

const CustomReportPage = (props) => {
  const {
    fetchApiKeyList,
    fetchApiList,
    fetchAppList,
    fetchAppListForOrgInContext,
    fetchGatewayList,
    fetchOrgList,
    isExternalUser,
    isOrgPublisher,
  } = props;

  const [filterByName, setFilterByName] = useState('');
  const [filterType, setFilterType] = useState('');

  useEffect(() => {
    if( filterType === FILTER_ENTITY_TYPE_API )
    {
      fetchApiList( filterByName );
    }
    else if( filterType === FILTER_ENTITY_TYPE_APP ) {
      if (isOrgPublisher) {
        fetchAppListForOrgInContext();
      } else {
        fetchAppList( filterByName );
      }
    }
    else if(filterType === FILTER_ENTITY_TYPE_ORG )
    {
        fetchOrgList( filterByName );
    }
  }, [filterByName, filterType]);

  useEffect(() => {
    fetchApiKeyList();
    fetchApiList();
    if (isOrgPublisher) {
      fetchAppListForOrgInContext();
    } else {
      fetchAppList();
    }
    if (!isExternalUser) {
      fetchOrgList();
      fetchGatewayList();
    } else if (isOrgPublisher) {
      fetchOrgList();
      fetchGatewayList();
    }
    fetchCustomReports();
  }, []);

  const onHandleSearchFilterNameChange = ( value ) => {
    setFilterByName(value);
  };

  const onEntityTypeChange = ( value ) => {
    setFilterType(value);
    setFilterByName("");
  };

  return (<CustomReport
    {...reportProps}
    {...props}
    handleSearchFilterNameChange={onHandleSearchFilterNameChange}
    onEntityTypeChange={onEntityTypeChange}
  />);
};

CustomReportPage.propTypes = {
  fetchApiKeyList: func,
  fetchApiList: func,
  fetchAppList: func,
  fetchAppListForOrgInContext: func,
  fetchGatewayList: func,
  fetchOrgList: func,
  isExternalUser: bool,
  isFeatureFlagAnalyticsOrgPublisherEnabled: bool,
  isOrgPublisher: bool,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(CustomReportPage);
